import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AlertProvider } from '@ascend/alert'
import 'calc-controls/styles.css'
import '../src/styles/index.css'
import '../src/styles/layout.css'
import '../src/styles/components.css'
import '../src/styles/themes.css'
import { AppLockProvider } from './components/AppLock/index.ts'
import { AppGate } from './AppGate.tsx'

const root = document.getElementById('root')
if (root) {
  createRoot(root).render(
    <StrictMode>
      <AlertProvider>
        <AppLockProvider>
          <AppGate />
        </AppLockProvider>
      </AlertProvider>
    </StrictMode>,
  )
}
